/**
 * Global configuration settings for the application
 */

// Single source for API base URL. Set VITE_API_URL in frontend/.env or Vercel env.
// Production: must be the full backend origin (e.g. https://api.edgetechnologies.com.au/api) so the session cookie is sent cross-origin.
const _viteApiUrl = import.meta.env.VITE_API_URL;
const DEFAULT_API_BASE =
  import.meta.env.DEV
    ? (_viteApiUrl && _viteApiUrl.trim()) || 'http://localhost:8000/api'
    : (() => {
        const url = (_viteApiUrl && _viteApiUrl.trim()) || '';
        if (!url) {
          throw new Error(
            'VITE_API_URL is not set. Add it to your Vercel environment variables before deploying.'
          );
        }
        return url;
      })();
export const API_BASE_URL = DEFAULT_API_BASE;
export const XER_API_BASE_URL = import.meta.env.VITE_XER_API_URL || DEFAULT_API_BASE;

// Feature flags
export const FEATURES = {
  ENABLE_NOTIFICATIONS: true,
  ENABLE_WORK_PACKAGES: true,
  ENABLE_TEAM_COLLABORATION: true,
  ENABLE_RESOURCE_MANAGEMENT: true,
};

// Debug: Log feature flags in development
if (import.meta.env.DEV) {
  console.log('🔍 Feature Flags:', FEATURES);
}

// Default pagination settings
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 10,
  MAX_PAGE_SIZE: 100,
};

// Date format settings
export const DATE_FORMATS = {
  DISPLAY: 'MMM D, YYYY',
  API: 'YYYY-MM-DD',
  DATETIME_DISPLAY: 'MMM D, YYYY h:mm A',
  DATETIME_API: 'YYYY-MM-DDTHH:mm:ss',
};

// File upload settings - Updated to include XER files
export const UPLOAD = {
  MAX_FILE_SIZE: 100 * 1024 * 1024, // 100MB for XER files
  ALLOWED_FILE_TYPES: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'image/jpeg',
    'image/png',
    'application/octet-stream', // For XER files
    'application/xml', // For XER files
  ],
  XER_FILE_EXTENSIONS: ['.xer'],
  XER_MAX_FILE_SIZE: 100 * 1024 * 1024, // 100MB specifically for XER files
};

// Default export for convenience
export default {
  API_BASE_URL,
  FEATURES,
  PAGINATION,
  DATE_FORMATS,
  UPLOAD,
};
